import React, { useState } from 'react'
import HubStockInfoForm from './HubStockInfoForm';
import HubStockInfoList from './HubStockInfoList';

const HubStockInfo= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <HubStockInfoForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <HubStockInfoList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default HubStockInfo;